// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5650":"227d9218","8777":"fe58350d"}[chunkId] + ".chunk.css";
};